'use strict';

/**
 * Listing of the recent exports
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoCompositeView = require('base/Colido.CompositeView');
var ExportRecentListItem = require('./export-recent-list-item');

var template = require('../../templates/partials/export-recent-list.hbs');

var ExportRecentList = ColidoCompositeView.extend({
    template: template,

    childView: ExportRecentListItem,

    childViewContainer: 'tbody',

    sortDefault: 'id.desc',
});

module.exports = ExportRecentList;